import { useState } from "react";
import * as Yup from "yup";
import {
    Box,
    Button,
    CircularProgress,
    IconButton,
    InputAdornment,
    TextField,
    Typography,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import { Link } from "react-router-dom";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useAuth } from "../../providers/AuthProvider";
import AuthSplitLayout, {
    authEyeSx,
    authFormSx,
    authLinkSx,
    authSubmitSx,
} from "../../components/AuthSplitLayout";

const validationSchema = Yup.object({
    user: Yup.string().required("Informe o usuário"),
    password: Yup.string()
        .min(5, "A senha deve ter pelo menos 6 caracteres")
        .required("Informe a senha"),
});

export default function Login() {
    const { signIn } = useAuth();
    const [showPassword, setShowPassword] = useState(false);

    return (
        <AuthSplitLayout title="Entrar" lead="Informe seu usuário e senha.">
            <Formik
                initialValues={{ user: "", password: "" }}
                validationSchema={validationSchema}
                onSubmit={async (values) => {
                    await signIn(values.user, values.password);
                }}
            >
                {({ errors, touched, isSubmitting }) => (
                    <Box component={Form} sx={authFormSx} noValidate>
                        <Field
                            as={TextField}
                            name="user"
                            label="Usuário"
                            autoComplete="username"
                            variant="outlined"
                            fullWidth
                            helperText={touched.user && errors.user ? errors.user : undefined}
                            error={touched.user && Boolean(errors.user)}
                        />

                        <Field
                            as={TextField}
                            name="password"
                            label="Senha"
                            autoComplete="current-password"
                            variant="outlined"
                            type={showPassword ? "text" : "password"}
                            fullWidth
                            helperText={touched.password && errors.password ? errors.password : undefined}
                            error={touched.password && Boolean(errors.password)}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
                                            onClick={() => setShowPassword((open) => !open)}
                                            edge="end"
                                            sx={authEyeSx}
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <Button
                            type="submit"
                            color="secondary"
                            variant="contained"
                            fullWidth
                            disabled={isSubmitting}
                            sx={authSubmitSx}
                        >
                            {isSubmitting ? (
                                <CircularProgress size={22} sx={{ color: "#fff" }} />
                            ) : (
                                "Entrar"
                            )}
                        </Button>

                        <Typography
                            component={Link}
                            to="/redefinicao-de-senha"
                            sx={authLinkSx}
                        >
                            Esqueceu a senha?
                        </Typography>
                    </Box>
                )}
            </Formik>
        </AuthSplitLayout>
    );
}
